/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * API
 * OpenAPI spec version: 1.0.0
 */

export type GetApiDoctorsPortalLogsSortBy =
    (typeof GetApiDoctorsPortalLogsSortBy)[keyof typeof GetApiDoctorsPortalLogsSortBy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiDoctorsPortalLogsSortBy = {
    createdAt: 'createdAt',
    seqId: 'seqId',
} as const;
